import { Component, Vue, Watch } from 'vue-property-decorator';

import template from './add-seat.vue';
import { Action } from '@/store';
import { ModalState, Company, Room } from '@/definitions';

@Component({
  mixins: [template],
})
export default class AddSeat extends Vue {
  name: string = '';
  showErrors: boolean = false;

  @Watch('$store.state.modal.active')
  resetComponent(active: boolean) {
    if (active) {
      if (this.modal.props.seat) {
        this.name = this.modal.props.seat.friendlyName;
      } else {
        this.name = '';
      }
      this.showErrors = false;
    }
  }

  mounted() {
    this.resetComponent(true);
  }

  get modal(): ModalState {
    return this.$Store.state.modal;
  }

  get company(): Company {
    return this.$Store.state.company.company;
  }

  get rooms(): Room[] {
    return this.$Store.state.company.rooms;
  }

  saveSeat() {
    if (this.name) {
      const rooms = [...this.rooms];
      if (this.modal.props.seat) {
        rooms[this.modal.props.roomIndex].seats[this.modal.props.seatIndex].friendlyName = this.name;
      } else {
        rooms[this.modal.props.roomIndex].seats.push({ friendlyName: this.name });
      }
      this.$Store.dispatch(Action.UPDATE_COMPANY, { company: this.company, rooms });
      this.closeModal();
    } else {
      this.showErrors = true;
    }
  }

  closeModal(): void {
    this.$Store.dispatch(Action.HIDE_MODAL);
  }
}